import {services_list} from '../../../lists/services-list'
import Select from 'react-select';
import {
    Form,
  } from "react-bootstrap";
import React from "react";

export default function ServiceForm(props) {
        let sortServices = props.sortServices;

        const handleChange = async (event) => {
            if (event && event.value) {
                sortServices(event.value)
            } else {
                sortServices('All')
            }

        }
        
        return (
            <div>
            <Form.Group controlId="insurances">
            <Form.Label>Service</Form.Label>
            <Select 
            options={services_list}
            isClearable={true}
            isSearchable={true}
            onChange={handleChange}
            />
            {/* }
            /> */}
            </Form.Group>
            </div>
        );

  }
  


